import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';

var r=create(a);

export { r as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-K7PMXFLS.mjs.map